import React, { useEffect, useState } from 'react';
import { Box, Button, Modal, IconButton, Typography } from '@material-ui/core';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import EditIcon from '@material-ui/icons/Edit';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import useToast from '../../../hooks/useToast';
import useLoader from '../../../hooks/useLoader';
import CustomForm from '../../../components/FormRenderer/CustomForm';

import {
  sanitizePayload,
  initializeFormData,
} from '../../../components/FormRenderer/utils';
import {
  createAkademySchool,
  getAllAkademySchools,
  updateAkademySchool,
} from '../AkademySlice';
import SchoolSessionModal from './SchoolSessionModal';
import { buzzOneUrl } from '../../../utils/enum';
import { AKADEMY_ONBOARDING_APP_URL, AUTH_TOKEN } from '../../../environments';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';

const AkademySchools = () => {
  const dispatch = useDispatch();
  const { ErrorToast, SuccessToast } = useToast();
  const { handleLoader } = useLoader();
  const [showFormModal, setFormModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [formTemplate, setFormTemplate] = useState(null);
  const [formData, setFormData] = useState({});
  const [search, setSearch] = useState('');

  const { schools, programmes, languages, classes } = useSelector(
    ({ akademyReducer }) => {
      return {
        schools: akademyReducer.schools,
        programmes: akademyReducer.programmes,
        languages: akademyReducer.languages,
        classes: akademyReducer.classes,
      };
    }
  );

  useEffect(() => {
    dispatch(getAllAkademySchools());
  }, []);

  useEffect(() => {
    dispatch(getAllAkademySchools({ searchText: search }));
  }, [search]);

  useEffect(() => {
    if (selectedRowId) {
      let newFormData = JSON.parse(
        JSON.stringify(schools.filter((item) => item._id === selectedRowId)[0])
      );
      if (newFormData.address) {
        if (newFormData.address.city)
          newFormData.city = newFormData.address.city;
        if (newFormData.address.state)
          newFormData.state = newFormData.address.state;
        if (newFormData.address.country)
          newFormData.country = newFormData.address.country;
        if (newFormData.address.pincode)
          newFormData.pincode = newFormData.address.pincode;
        delete newFormData.address;
      }
      if (newFormData.usageExpiryDate)
        newFormData.usageExpiryDate = newFormData.usageExpiryDate.split('T')[0];
      if (newFormData.agreementExpiryDate)
        newFormData.agreementExpiryDate =
          newFormData.agreementExpiryDate.split('T')[0];

      if (newFormData.class) {
        const classesStringArr = classes.map(({ code }) => {
          return code;
        });
        newFormData.class = newFormData.class.filter((cls) => {
          if (classesStringArr.includes(cls)) return true;
          return false;
        });
      }
      if (newFormData.language) {
        const languagesStringArr = languages.map(({ code }) => {
          return code;
        });
        newFormData.language = newFormData.language.filter((cls) => {
          if (languagesStringArr.includes(cls)) return true;
          return false;
        });
      }

      console.log(newFormData);
      setFormData(newFormData);
    } else setFormData(initializeFormData(formTemplate));
  }, [selectedRowId]);

  useEffect(() => {
    if (!programmes || !languages || !classes) return;

    const formTemplate = [
      {
        id: 'form.name',
        title: 'Name',
        slug: 'name',
        type: 'String',
        required: true,
      },
      {
        id: 'form.contactNumber',
        title: 'Contact Number',
        slug: 'contactNumber',
        type: 'String',
        required: true,
      },
      {
        id: 'form.emailId',
        title: 'Email Id',
        slug: 'emailId',
        type: 'String',
        required: true,
      },
      {
        id: 'form.status',
        title: 'Status',
        slug: 'status',
        type: 'Select',
        options: [
          { label: 'Publish', value: 'PUBLISHED' },
          { label: 'InActive', value: 'INACTIVE' },
        ],
      },

      {
        id: 'form.address.city',
        title: 'City',
        slug: 'city',
        type: 'String',
      },
      {
        id: 'form.address.state',
        title: 'State',
        slug: 'state',
        type: 'String',
      },
      {
        id: 'form.address.country',
        title: 'Country',
        slug: 'country',
        type: 'String',
      },
      {
        id: 'form.address.pincode',
        title: 'Pincode',
        slug: 'pincode',
        type: 'String',
      },
    ];
    setFormTemplate(formTemplate);

    setFormData(initializeFormData(formTemplate));
  }, [programmes, languages, classes]);

  const schoolsColumn = [
    {
      Header: 'School',
      Cell: (val) => {
        return (
          <>
            <Typography>{val.cell.row.original.name}</Typography>
            <Typography style={{ opacity: 0.5, fontSize: '0.85rem' }}>
              {val.cell.row.original._id}
            </Typography>
          </>
        );
      },
    },
    // { Header: 'SchoolId', accessor: '_id' },
    // { Header: 'Name', accessor: 'name' },
    // { Header: 'Email', accessor: 'email' },
    // { Header: 'Mobile', accessor: 'mobile' },
    // {
    //   Header: 'PII',
    //   Cell: (val) => {
    //     return (
    //       <>
    //         <p>{val.cell.row.original.emailId}</p>
    //         <p>{val.cell.row.original.contactNumber}</p>
    //       </>
    //     );
    //   },
    // },
    { Header: 'Status', accessor: 'status' },
    {
      Header: 'Session',
      // accessor: '',
      Cell: (val) => {
        const payload = val.cell.row.original;
        const { _id } = payload;

        const [openModal, setOpenModal] = useState(false);
        const [academicSessions, setAcademicSessions] = useState([]);

        const handleOpen = () => {
          fetch(`${buzzOneUrl}/akademy/sessions/school/${_id}`)
            .then(async (res) => {
              const data = await res.json();

              setOpenModal(true);
              setAcademicSessions(data.data);
            })
            .catch(() => {
              ErrorToast(
                'Something went wrong while fetching academic sessions'
              );
            });
        };

        const [openAddModal, setOpenAddModal] = useState(false);
        const showAddModel = () => {
          setOpenAddModal(true);
        };

        return (
          <>
            <SchoolSessionModal
              academicSessions={academicSessions}
              showAddModel={showAddModel}
              open={openModal}
              onClose={() => {
                setOpenModal(false);
              }}
            />
            <Box
              onClick={handleOpen}
              sx={{ cursor: 'pointer', textDecoration: 'underline' }}>
              Academic Sessions
            </Box>
          </>
        );
      },
    },
    {
      Header: 'Edit',
      Cell: (val) => {
        const { _id: schoolId } = val.cell.row.original;

        return (
          <a
            href={`${AKADEMY_ONBOARDING_APP_URL}?school_id=${schoolId}&&auth_token=${AUTH_TOKEN}`}
            target="_blanh">
            Onboard / Edit School Details
          </a>
        );
      },
    },
    {
      Header: 'Action',
      Cell: (val) => {
        const { _id } = val.cell.row.original;

        return (
          <>
            <IconButton onClick={() => handleEdit(_id)}>
              <EditIcon color="secondary" />
            </IconButton>
          </>
        );
      },
    },
  ];

  const openFormModal = () => setFormModal(true);
  const closeFormModal = () => setFormModal(false);

  const handleEdit = (id) => {
    setSelectedRowId(id);
    openFormModal();
  };

  const handleCreateNew = () => {
    setSelectedRowId(null);
    openFormModal();
  };

  const handleSave = async () => {
    handleLoader(true);
    let payload = sanitizePayload(formData);

    dispatch(
      selectedRowId === null
        ? createAkademySchool(payload)
        : updateAkademySchool({ id: selectedRowId, data: payload })
    )
      .unwrap()
      .then((res) => {
        console.log(res);
        SuccessToast(res.message);
        dispatch(getAllAkademySchools());
        closeFormModal();
      })
      .catch((error) => {
        console.error('rejected', error);
        ErrorToast(error.message);
      });

    handleLoader(false);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box width={500}>
          <BuzzInput
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            name="search"
            size="small"
            placeholder="Search by School Name"
            search
          />
        </Box>
        <Button onClick={handleCreateNew} variant={'contained'} color="primary">
          Add School
        </Button>
      </Box>
      <Box my={2}>
        <BuzzTable
          columns={schoolsColumn}
          data={schools}
          isHandlePagination={true}
        />
      </Box>
      <Modal open={showFormModal} onClose={closeFormModal}>
        <CustomForm
          formFor={'School'}
          formTemplate={formTemplate}
          formData={formData}
          setFormData={(slug, newValue) => {
            setFormData((state) => {
              state[slug] = newValue;
              return state;
            });
            setFormTemplate((state) => {
              return JSON.parse(JSON.stringify(state));
            });
          }}
          mode={selectedRowId === null ? 'CREATE' : 'EDIT'}
          handleSave={handleSave}
        />
      </Modal>
    </Box>
  );
};

export default AkademySchools;
